import { AvailabilityService } from './availability';
import { BookingService } from './booking';
import { ConsentService } from './consent';
import { PatientService } from './patient';
import { SiteService } from './site';
import { UserService } from './user';
var ApiSettings = /** @class */ (function () {
    function ApiSettings() {
    }
    Object.defineProperty(ApiSettings.prototype, "SiteId", {
        set: function (siteid) {
            this.siteid = siteid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiSettings.prototype, "BaseUrl", {
        set: function (url) {
            this.baseUrl = url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiSettings.prototype, "ServiceUrl", {
        get: function () {
            return "".concat(this.baseUrl, "/v1");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiSettings.prototype, "SiteUrl", {
        get: function () {
            return "".concat(this.baseUrl, "/v1/site/").concat(this.siteid);
        },
        enumerable: false,
        configurable: true
    });
    return ApiSettings;
}());
export var apiSettings = new ApiSettings();
export var availabilityService = new AvailabilityService();
export var bookingService = new BookingService();
export var consentService = new ConsentService();
export var patientService = new PatientService();
export var siteService = new SiteService();
export var userService = new UserService();
